/**
 * Decisão de rota centralizada (P23H): /inicio é o destino padrão da
 * experiência autenticada — login, cadastro/verificação, restauração de
 * sessão e qualquer guard que precise "mandar o usuário autenticado para
 * algum lugar" devem importar esta constante em vez de hardcodar '/chat'
 * ou '/inicio' em cada componente. Evita redirects divergentes entre
 * LoginPage, App.jsx e outros guards.
 */
export const DEFAULT_AUTHENTICATED_ROUTE = '/inicio';
